import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface DeleteRequestData {
        id: number;
        addressId: number;
        userId: number;
        deleteReason: string;
        createdDate: string;
        deleteStatus: boolean;
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        pinCode: string;
        blockCode: string;
        addressCode: string;
        latitude: string;
        longitude: string;
        userName: string;
        email: string;
        phoneNumber: number;
      }

export const GetAllDeleteRequestsAsync = async (token: string): Promise<DeleteRequestData[]> => {
  const baseUrl = getApiBaseUrl();  
  const apiUrl = `${baseUrl}/api/Admin/GetAllDeleteRequestsAsync`;
  
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error(`Failed to fetch delete requests: ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      // console.error("Error in GetAllDeleteRequestsAsync:", error);
      throw error;
    }
  };
  